import { IconName } from "shared/ui/icon/__generated__/IconName"

export interface ProcessStep<T extends string = string> {
  label: string
  description: string
  icon: IconName
  value: T
  status?: ProcessStepStatus
}

// Domain facts only the caller can know. Kept separate from the step's position in
// the flow so a caller cannot express a contradiction such as two current steps.
export enum ProcessStepStatus {
  SKIPPED = "SKIPPED",
  FAILED = "FAILED"
}

export enum ProcessStepPosition {
  PAST = "PAST",
  CURRENT = "CURRENT",
  FUTURE = "FUTURE"
}

export enum ProcessStepState {
  DONE = "DONE",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
  CURRENT = "CURRENT",
  FUTURE = "FUTURE"
}
